import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // vuex中的数据源，我们需要保存的数据就保存在这里，可以在页面通过 this.$store.state来获取我们定义的数据；
  state: {
    show: 'loading', // 当前页面
    screen: 'screen1', // 当前页面
    cityGlobel: {}, // 当前数据
    totalMsg: 0, // 总统计
    showHand: false,
    clickMap: false,
  },
  // Getter相当于vue中的computed计算属性，getter 的返回值会根据它的依赖被缓存起来，且只有当它的依赖值发生了改变才会被重新计算，这里我们可以通过定义vuex的Getter来获取，Getters 可以用于监听、state中的值的变化
  getters: {
    getToDo(state) {
      return state.todos.filter(item => item.done === true)
    }
  },
  // 数据我们在页面是获取到了，但是如果我们需要修改count值怎么办？如果需要修改store中的值唯一的方法就是提交mutation来修改，
  mutations: {
    setPage(state, str) {
      state.show = str
    },
    setShowHand(state, str) {
      state.showHand = str
    },
    setclickMap(state, str) {
      state.clickMap = str
    },
    setScreen(state, str) {
      state.screen = str
    },
    setCityGlobel(state, str) {
      state.cityGlobel = str
    },
    setTotalMsg(state, str) {
      state.totalMsg = str
    }
  },
  // 官方并不建议我们这样直接去修改store里面的值，而是让我们去提交一个actions，在actions中提交mutation再去修改状态值
  actions: {
    setPageFn(context, str) {
      context.commit('setPage', str)
    },
    setShowHandFn(context, str) {
      context.commit('setShowHand', str)
    },
    setclickMapFn(context, str) {
      context.commit('setclickMap', str)
    },
    setScreenFn(context, str) {
      context.commit('setScreen', str)
    },
    setCityGlobelFn(context, str) {
      context.commit('setCityGlobel', str)
    },
    setTotalMsgFn(context, str) {
      context.commit('setTotalMsg', str)
    }
  },
  modules: {}
})
